import React, {useContext, useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeNotification, {
  BRDS_SIZE as moleculeNotificationBorderRadiusSize,
  TYPES as moleculeNotificationTypes,
  VARIATIONS as moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'

export const DiscardAdNotifications = ({showNotification, className}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const [notificationType, setNotificationType] = useState(showNotification && moleculeNotificationTypes.success)

  const baseNotificationProps = {
    position: 'relative',
    roundedCorners: moleculeNotificationBorderRadiusSize.medium,
    show: true,
    showCloseButton: false,
    variation: moleculeNotificationVariations.negative
  }

  const notificationText = {
    [moleculeNotificationTypes.warning]: 'COMMON.AD_DISCARD_NOTIFICATION_ERROR',
    [moleculeNotificationTypes.success]: 'COMMON.AD_DISCARD_NOTIFICATION_SUCCESS'
  }

  useEffect(() => {
    const onDiscardSubscription = ({result}) => {
      const [useCaseError, useCaseResponse] = result
      const {USER_NOT_LOGGED_IN_USER_ERROR} = config.get('ERRORS')
      const userIsNotLoggedIn = useCaseError instanceof USER_NOT_LOGGED_IN_USER_ERROR

      useCaseError && !userIsNotLoggedIn && setNotificationType(moleculeNotificationTypes.warning)
      useCaseResponse && setNotificationType(moleculeNotificationTypes.success)
    }

    const {unsubscribe} = domain.get('add_user_discarded_ads_use_case').subscribe(onDiscardSubscription)

    return unsubscribe
  })

  const onClose = () => setNotificationType(null)

  return notificationType ? (
    <div className={cx('mt-AdsList-pageNotifications', className)}>
      <MoleculeNotification {...baseNotificationProps} type={notificationType} onClose={onClose}>
        {i18n.t(notificationText[notificationType])}
      </MoleculeNotification>
    </div>
  ) : (
    <></>
  )
}

DiscardAdNotifications.propTypes = {
  showNotification: PropTypes.bool,
  className: PropTypes.string
}
